import { envs } from "application/envHandler";
import { Dispatch } from 'application/redux';
import apiClient from "core/api";
import authService from 'core/auth';
import { add, remove } from "core/spinner/redux/actions";
import { addToaster } from "core/toaster/redux/actions";
import { ToasterType } from 'core/toaster/redux/types';
import { FETCH_WIFI_ENTRIES, RESET_STATE, WIFI_SUCCESS, WifiDashboardsAPIResponse } from "./types";

function fetchSuccess(payload: WifiDashboardsAPIResponse) {
  return {
    type: WIFI_SUCCESS,
    payload,
  }
}

function resetState() {
  return {
    type: RESET_STATE
  }
}

export function onExit() {
  return (dispatch: Dispatch) => {
    dispatch(resetState())
  }
}

export function fetchWifiData(deviceId: string) {
  return async (dispatch: Dispatch) => {
    dispatch(add(FETCH_WIFI_ENTRIES, {}))
    await authService.refreshToken()
    try {
      const { data } = await apiClient.get(`/wifi/device/${deviceId}`, {
        baseURL: envs.REACT_APP_API_URL
      })

      if (data) {
        dispatch(fetchSuccess(data))
      }
    } catch (e) {
      dispatch(
        addToaster({
          title: 'all_device_pages.menu_wifi_dashboards',
          message: 'error_messages.VIPOC_ERROR_069',
          type: ToasterType.danger
        })
      )
    } finally {
      dispatch(remove(FETCH_WIFI_ENTRIES))
    }
  }
}